import{isObject as n}from"@guildeducationinc/type-guards";var r=function(r){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:function(n){return!1};return n(r)&&"props"in r&&"type"in r||t(r)};export{r as isReactElementOr};
